import { SvgIcon, SvgIconProps } from '@mui/material';

// ----------------------------------------------------------------------

// CloseIcon
export function CloseIcon(props: SvgIconProps) {
  return (
    <SvgIcon {...props}>
      <path d="M12,2 C6.48,2 2,6.48 2,12 C2,17.52 6.48,22 12,22 C17.52,22 22,17.52 22,12 C22,9.35 20.95,6.8 19.07,4.93 C17.2,3.05 14.65,2 12,2 Z M14.71,13.29 C14.9,13.48 15.01,13.73 15.01,14 C15.01,14.27 14.9,14.52 14.71,14.71 C14.52,14.9 14.27,15.01 14,15.01 C13.73,15.01 13.48,14.9 13.29,14.71 L12,13.41 L10.71,14.71 C10.52,14.9 10.27,15.01 10,15.01 C9.73,15.01 9.48,14.9 9.29,14.71 C9.1,14.52 8.99,14.27 8.99,14 C8.99,13.73 9.1,13.48 9.29,13.29 L10.59,12 L9.29,10.71 C8.9,10.32 8.9,9.68 9.29,9.29 C9.68,8.9 10.32,8.9 10.71,9.29 L12,10.59 L13.29,9.29 C13.68,8.9 14.32,8.9 14.71,9.29 C15.1,9.68 15.1,10.32 14.71,10.71 L13.41,12 L14.71,13.29 Z" />
    </SvgIcon>
  );
}

// StarIcon
export function StarIcon(props: SvgIconProps) {
  return (
    <SvgIcon {...props}>
      <path d="M17.56,21 C17.4,21 17.24,20.96 17.1,20.89 L12,18.22 L6.9,20.89 C6.56,21.07 6.15,21.04 5.84,20.81 C5.54,20.59 5.38,20.21 5.45,19.83 L6.45,14.2 L2.33,10.2 C2.07,9.94 1.97,9.55 2.08,9.2 C2.2,8.84 2.51,8.57 2.89,8.52 L8.59,7.69 L11.1,2.56 C11.27,2.22 11.62,2 12,2 C12.38,2 12.73,2.22 12.9,2.56 L15.44,7.68 L21.14,8.51 C21.52,8.56 21.83,8.83 21.95,9.19 C22.06,9.54 21.96,9.93 21.7,10.19 L17.58,14.19 L18.58,19.82 C18.65,20.2 18.5,20.59 18.18,20.82 C18,20.95 17.78,21.01 17.56,21 L17.56,21 Z" />
    </SvgIcon>
  );
}

// Using for Alert
export function InfoIcon(props: SvgIconProps) {
  return (
    <SvgIcon {...props}>
      <path d="M12,2 C6.48,2 2,6.48 2,12 C2,17.52 6.48,22 12,22 C17.52,22 22,17.52 22,12 C22,9.35 20.95,6.8 19.07,4.93 C17.2,3.05 14.65,2 12,2 Z M13,16 C13,16.55 12.55,17 12,17 C11.45,17 11,16.55 11,16 L11,11 C11,10.45 11.45,10 12,10 C12.55,10 13,10.45 13,11 L13,16 Z M12,9 C11.45,9 11,8.55 11,8 C11,7.45 11.45,7 12,7 C12.55,7 13,7.45 13,8 C13,8.55 12.55,9 12,9 Z" />
    </SvgIcon>
  );
}

export function WarningIcon(props: SvgIconProps) {
  return (
    <SvgIcon {...props}>
      <path d="M22.56,16.3 L14.89,3.58 C14.26,2.59 13.17,2 12,2 C10.83,2 9.74,2.59 9.11,3.58 L1.44,16.3 C0.89,17.22 0.87,18.36 1.39,19.3 C1.99,20.36 3.12,21 4.33,21 L19.67,21 C20.88,21.01 22,20.38 22.61,19.34 C23.15,18.39 23.13,17.23 22.56,16.3 L22.56,16.3 Z M12,17 C11.45,17 11,16.55 11,16 C11,15.45 11.45,15 12,15 C12.55,15 13,15.45 13,16 C13,16.55 12.55,17 12,17 Z M13,13 C13,13.55 12.55,14 12,14 C11.45,14 11,13.55 11,13 L11,9 C11,8.45 11.45,8 12,8 C12.55,8 13,8.45 13,9 L13,13 Z" />
    </SvgIcon>
  );
}

export function SuccessIcon(props: SvgIconProps) {
  return (
    <SvgIcon {...props}>
      <path d="M12,2 C6.48,2 2,6.48 2,12 C2,17.52 6.48,22 12,22 C17.52,22 22,17.52 22,12 C22,9.35 20.95,6.8 19.07,4.93 C17.2,3.05 14.65,2 12,2 Z M16.3,9.61 L11.73,15.61 C11.54,15.86 11.25,16 10.94,16 C10.63,16 10.34,15.86 10.15,15.62 L7.71,12.51 C7.49,12.23 7.44,11.85 7.57,11.52 C7.71,11.19 8.01,10.95 8.36,10.9 C8.72,10.85 9.07,11 9.29,11.28 L10.92,13.36 L14.7,8.36 C14.92,8.07 15.27,7.93 15.63,7.97 C15.98,8.02 16.29,8.25 16.43,8.58 C16.57,8.91 16.52,9.29 16.3,9.58 L16.3,9.61 Z" />
    </SvgIcon>
  );
}

export function ErrorIcon(props: SvgIconProps) {
  return (
    <SvgIcon {...props}>
      <path d="M12,2 C6.48,2 2,6.48 2,12 C2,17.52 6.48,22 12,22 C17.52,22 22,17.52 22,12 C22,9.35 20.95,6.8 19.07,4.93 C17.2,3.05 14.65,2 12,2 Z M12,17 C11.45,17 11,16.55 11,16 C11,15.45 11.45,15 12,15 C12.55,15 13,15.45 13,16 C13,16.55 12.55,17 12,17 Z M13,13 C13,13.55 12.55,14 12,14 C11.45,14 11,13.55 11,13 L11,8 C11,7.45 11.45,7 12,7 C12.55,7 13,7.45 13,8 L13,13 Z" />
    </SvgIcon>
  );
}

// Using for Checkbox
export function CheckboxIcon(props: SvgIconProps) {
  return (
    <SvgIcon {...props}>
      <path d="M17 3a4 4 0 014 4v10a4 4 0 01-4 4H7a4 4 0 01-4-4V7a4 4 0 014-4h10zm0 2H7a2 2 0 00-2 2v10a2 2 0 002 2h10a2 2 0 002-2V7a2 2 0 00-2-2z" />
    </SvgIcon>
  );
}

export function CheckboxCheckedIcon(props: SvgIconProps) {
  return (
    <SvgIcon {...props}>
      <path d="M17 3a4 4 0 014 4v10a4 4 0 01-4 4H7a4 4 0 01-4-4V7a4 4 0 014-4h10zm-1.37 4.97a1.01 1.01 0 00-.928.39l-3.78 5-1.63-2.08a1 1 0 00-1.58 1.23l2.44 3.11a1 1 0 001.58-.01l4.57-6v-.03a1.01 1.01 0 00-.672-1.61z" />
    </SvgIcon>
  );
}

export function CheckboxIndeterminateIcon(props: SvgIconProps) {
  return (
    <SvgIcon {...props}>
      <path d="M17 3a4 4 0 014 4v10a4 4 0 01-4 4H7a4 4 0 01-4-4V7a4 4 0 014-4h10zm-1.75 8h-6.5a.75.75 0 00-.75.75v.5c0 .414.34.75.75.75h6.5a.75.75 0 00.75-.75v-.5a.75.75 0 00-.75-.75z" />
    </SvgIcon>
  );
}

// Using for Select Input
export function InputSelectIcon(props: SvgIconProps) {
  return (
    <SvgIcon
      {...props}
      sx={{
        right: 12,
        fontSize: 16,
        position: 'absolute',
        pointerEvents: 'none',
      }}
    >
      <path d="M12,16 C11.77,16 11.54,15.92 11.36,15.77 L5.36,10.77 C4.93,10.42 4.88,9.79 5.23,9.36 C5.58,8.93 6.21,8.88 6.64,9.23 L12,13.71 L17.36,9.39 C17.57,9.22 17.83,9.14 18.1,9.17 C18.36,9.2 18.6,9.33 18.77,9.54 C18.96,9.75 19.05,10.02 19.02,10.3 C18.99,10.58 18.85,10.83 18.63,11 L12.63,15.83 C12.44,15.96 12.22,16.02 12,16 Z" />
    </SvgIcon>
  );
}

//  Using for TreeView
export function TreeViewCollapseIcon(props: SvgIconProps) {
  return (
    <SvgIcon {...props}>
      <path d="M18,3 C19.66,3 21,4.34 21,6 L21,6 L21,18 C21,19.66 19.66,21 18,21 L18,21 L6,21 C4.34,21 3,19.66 3,18 L3,18 L3,6 C3,4.34 4.34,3 6,3 L6,3 Z M18,5 L6,5 C5.45,5 5,5.45 5,6 L5,6 L5,18 C5,18.55 5.45,19 6,19 L6,19 L18,19 C18.55,19 19,18.55 19,18 L19,18 L19,6 C19,5.45 18.55,5 18,5 L18,5 Z M12,8 C12.55,8 13,8.45 13,9 L13,9 L13,11 L15,11 C15.55,11 16,11.45 16,12 C16,12.55 15.55,13 15,13 L15,13 L13,13 L13,15 C13,15.55 12.55,16 12,16 C11.45,16 11,15.55 11,15 L11,15 L11,13 L9,13 C8.45,13 8,12.55 8,12 C8,11.45 8.45,11 9,11 L9,11 L11,11 L11,9 C11,8.45 11.45,8 12,8 Z" />
    </SvgIcon>
  );
}

export function TreeViewExpandIcon(props: SvgIconProps) {
  return (
    <SvgIcon {...props}>
      <path d="M18,3 C19.66,3 21,4.34 21,6 L21,6 L21,18 C21,19.66 19.66,21 18,21 L18,21 L6,21 C4.34,21 3,19.66 3,18 L3,18 L3,6 C3,4.34 4.34,3 6,3 L6,3 Z M18,5 L6,5 C5.45,5 5,5.45 5,6 L5,6 L5,18 C5,18.55 5.45,19 6,19 L6,19 L18,19 C18.55,19 19,18.55 19,18 L19,18 L19,6 C19,5.45 18.55,5 18,5 L18,5 Z M15,11 C15.55,11 16,11.45 16,12 C16,12.55 15.55,13 15,13 L15,13 L9,13 C8.45,13 8,12.55 8,12 C8,11.45 8.45,11 9,11 L9,11 Z" />
    </SvgIcon>
  );
}

export function TreeViewEndIcon(props: SvgIconProps) {
  return (
    <SvgIcon {...props}>
      <path d="M18,3 C19.66,3 21,4.34 21,6 L21,6 L21,18 C21,19.66 19.66,21 18,21 L18,21 L6,21 C4.34,21 3,19.66 3,18 L3,18 L3,6 C3,4.34 4.34,3 6,3 L6,3 Z M18,5 L6,5 C5.45,5 5,5.45 5,6 L5,6 L5,18 C5,18.55 5.45,19 6,19 L6,19 L18,19 C18.55,19 19,18.55 19,18 L19,18 L19,6 C19,5.45 18.55,5 18,5 L18,5 Z M14,8.99 C14.27,8.99 14.52,9.1 14.71,9.29 C14.9,9.48 15.01,9.73 15.01,10 C15.01,10.27 14.9,10.52 14.71,10.71 L14.71,10.71 L13.41,12 L14.71,13.29 C14.9,13.48 15.01,13.73 15.01,14 C15.01,14.27 14.9,14.52 14.71,14.71 C14.52,14.9 14.27,15.01 14,15.01 C13.73,15.01 13.48,14.9 13.29,14.71 L13.29,14.71 L12,13.41 L10.71,14.71 C10.52,14.9 10.27,15.01 10,15.01 C9.73,15.01 9.48,14.9 9.29,14.71 C9.1,14.52 8.99,14.27 8.99,14 C8.99,13.73 9.1,13.48 9.29,13.29 L9.29,13.29 L10.59,12 L9.29,10.71 C8.9,10.32 8.9,9.68 9.29,9.29 C9.68,8.9 10.32,8.9 10.71,9.29 L10.71,9.29 L12,10.59 L13.29,9.29 C13.48,9.1 13.73,8.99 14,8.99 Z" />
    </SvgIcon>
  );
}
